var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.826,
    height: 27.006,
    viewBox: "0 0 23.826 27.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comment_plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}.b{fill:#fff;stroke:rgba(0,0,0,0);font-size:15px;font-family:HelveticaNeue-Bold, Helvetica Neue;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.814,5.383A2.379,2.379,0,0,0,24.444,3H5.383A2.39,2.39,0,0,0,3,5.383v14.3a2.39,2.39,0,0,0,2.383,2.383H22.061l4.765,4.765Z",
    transform: "translate(-3 -0.82)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(6.419 15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentPlus);
export default __webpack_public_path__ + "static/media/comment_plus.84424dadb5ea2dd22dd526552a72ec53.svg";
export { ForwardRef as ReactComponent };